import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=56469eeb&scoped=true"
import script from "./choice.vue?vue&type=script&lang=ts"
export * from "./choice.vue?vue&type=script&lang=ts"
import style0 from "./choice.vue?vue&type=style&index=0&id=56469eeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56469eeb",
  null
  
)

export default component.exports